/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './DebtInformationList.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { setEditDebtInfo, listDeleteAction } from 'redux/actions'

const getAmountString = (i18n, num) => {
  const amt = (num * 0.01).toFixed(2)
  try {
    return i18n.language === 'en' ? `$${amt}` : `${amt.toString().replace('.', ',')} $`
  } catch (e) {
    console.log(e)
  }
}

const DebtInformationListTable = ({ t, i18n, setIsError, reviewConfirmation = false, isSummary = false }) => {
  let history = useHistory()

  const debtInformationList = useSelector((state) => state.app.debtInformationList)
  const dispatch = useDispatch()

  useEffect(() => {
    try {
      if (debtInformationList.length === 0) {
        history.push(`/${i18n.language}${t('routes.vehicle_tax_debt')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [debtInformationList, history, i18n.language, isSummary, setIsError, t, dispatch])

  const amountTotal = useMemo(
    () => debtInformationList.reduce((prev, debtInfo) => prev + parseFloat(debtInfo.paymentAmount), 0),
    [debtInformationList]
  )

  const [fileNumberList, vinList] = useMemo(() => {
    const fileNumberList = debtInformationList.filter((list) => !list.isVehicleTaxDebt)
    const vinList = debtInformationList.filter((list) => list.isVehicleTaxDebt)
    return [fileNumberList, vinList]
  }, [debtInformationList])

  const editOnClick = (editFileNumber) => () => {
    try {
      dispatch(setEditDebtInfo(editFileNumber))
      if (reviewConfirmation) {
        // TODO: HOOKUP
        // dispatch(editFromConfirmationAction(true));
      }
      history.push(`/${i18n.language}${t('routes.debt_info')}?isSummary=${isSummary}`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const removeOnClick = (deleteFileNumber) => () => {
    try {
      let confirmText = window.confirm(`${t('are_you_sure')}`)
      if (confirmText === true) {
        dispatch(listDeleteAction('debtInfo', deleteFileNumber))
        history.push(`/${i18n.language}${t('routes.review_summary')}`)
        // if (reviewConfirmation) {
        //   history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
        // } else {
        //   history.push(`/${i18n.language}${t('routes.debt_info_list')}`)
        // }
      }
      // dispatch(listDeleteAction("debtInfo", deleteFileNumber))
      // if (reviewConfirmation) {
      //     // history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
      // }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  const updateIsMobile = useCallback(() => {
    setIsMobile(window.innerWidth <= 768)
  }, [])

  useEffect(() => {
    window.addEventListener('resize', updateIsMobile)
    return () => {
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [updateIsMobile])

  return (
    <Fragment>
      {fileNumberList.length > 0 &&
        fileNumberList.map((row) => (
          <Fragment>
            <div className="row">
              <div className="col-xs-12 col-lg-8">
                <h2>{t('review_confirmation.debt_information')}</h2>
              </div>
              <div className="button-group">
                <button className="edit-button" onClick={editOnClick(row.fileNumber)} value={t('shared.edit')} name={t('shared.edit')}>
                  {t('shared.edit')}
                </button>
                <button
                  className="remove-button"
                  onClick={removeOnClick(row.fileNumber)}
                  value={t('shared.remove')}
                  name={t('shared.remove')}
                >
                  {t('shared.remove')}
                </button>
              </div>
            </div>
            <div className="row row-odd">
              <div className="col-xs-6">
                <strong>{t('debt_info.file_number_shortened')}</strong>
              </div>
              <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
                {row.fileNumber}
              </div>
            </div>
            <div className="row row-even">
              <div className="col-xs-6">
                <strong>{t('debt_info.amount')}</strong>
              </div>
              <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
                {getAmountString(i18n, parseFloat(row.paymentAmount))}
              </div>
            </div>
          </Fragment>
        ))}
      {vinList.length > 0 &&
        vinList.map((row) => (
          <Fragment>
            <div className="row">
              <div className="col-xs-12 col-lg-8">
                <h2>{t('review_confirmation.vehicle_debt_information')}</h2>
              </div>
              <div className="button-group">
                <button className="edit-button" onClick={editOnClick(row.fileNumber)} value={t('shared.edit')} name={t('shared.edit')}>
                  {t('shared.edit')}
                </button>
                <button
                  className="remove-button"
                  onClick={removeOnClick(row.fileNumber)}
                  value={t('shared.remove')}
                  name={t('shared.remove')}
                >
                  {t('shared.remove')}
                </button>
              </div>
            </div>
            <div className="row row-odd">
              <div className="col-xs-6">
                <strong>{t('debt_info.vin_abbreviated')}</strong>
              </div>
              <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
                {row.fileNumber}
              </div>
            </div>

            <div className="row row-even">
              <div className="col-xs-6">
                <strong>{t('debt_info.amount')}</strong>
              </div>
              <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
                {getAmountString(i18n, parseFloat(row.paymentAmount))}
              </div>
            </div>
          </Fragment>
        ))}
      <br />
      <div className="row row-odd">
        <div className="col-xs-6">
          <strong>{t('debt_info.total')}</strong>
        </div>
        <div className="col-xs-6" style={{ lineBreak: 'anywhere' }}>
          <b>{getAmountString(i18n, amountTotal)}</b>
        </div>
      </div>
    </Fragment>
  )
}

export default withTranslation('common')(DebtInformationListTable)
